import React, { useEffect, useState, useCallback } from 'react'
import Container from '../Container/Container';
import { useNavigate } from 'react-router-dom';
import Loader from '../Pages/Component/Loader';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { get, ImageUrl } from '../ApiServices/ApiServices';
import 'bootstrap-daterangepicker/daterangepicker.css';
import AccountOverviewTable from './DashComponent/AccountOverviewTable';
import RecentOrdersTab from './DashComponent/RecentOrdersTab';
import MostRental from './DashComponent/MostRental';
import ActiveRentalTab from './DashComponent/ActiveRentalTab';
import TopFiveRental from './DashComponent/TopFiveRental';
import TopMetrics from './DashComponent/TopMetrics';
import { useSelector } from 'react-redux';
function Dashboard() {
   const [AccOverview, setAccOverview] = useState([])
   const [loading, setLoading] = useState(true);
   const [Orderview, setOrderview] = useState([])
   const navigate = useNavigate();

   const [MonthlyComp, setMonthlyComp] = useState([])
   const [SalesPerf, setSalesPerf] = useState([])
   const [MonthlyComparisonNew, setMonthlyComparisonNew] = useState([])
   const [topStores, setTopStores] = useState([]);
   const [salesChartData, setSalesChartData] = useState([]);
   const [salesChartMax, setSalesChartMax] = useState(100);




   const [ActiveOrder, setActiveOrder] = useState([])

   const ActiveOrders = async () => {
      try {

         const api = `active-orders`;
         const response = await get(api);

         if (response?.status == true) {
            setActiveOrder(response?.total);
            setLoading(false)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
         // setLoading(false)
      }
   };

   useEffect(() => {
      ActiveOrders();
   }, [])


   const fetchTopStores = async (year) => {
      try {
         const api = `topFiveStores?year=${year || new Date().getFullYear()}`;
         const response = await get(api);

         if (response?.status === true) {
            setTopStores(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);

         if (
            err?.message === "Invalid or expired token" ||
            err?.message === "Invalid Token"
         ) {
            localStorage.removeItem("token");
            navigate("/login");
         }
      }
   };
   useEffect(() => {
      fetchTopStores();
   }, []);
   useEffect(() => {
      if (!topStores || topStores.length === 0) return;

      const formattedData = topStores.map((item) => ({
         name: item.account,
         current: parseInt(item.wedding_orders || 0),
         previous: parseInt(item.single_orders || 0),
         prom: parseInt(item.prom_orders || 0),
      }));

      setSalesChartData(formattedData);

      const maxValue = Math.max(
         ...formattedData.map((i) =>
            Math.max(i.current, i.previous, i.prom)
         )
      );

      setSalesChartMax(maxValue + 10);

   }, [topStores]);



   const MonthlyComparisonNewAPI = async () => {
      try {

         const api = `monthly-comparison`;
         const response = await get(api);
         if (response?.status == true) {
            setLoading(false)
            console.log(response?.data, "response?.data")
            setMonthlyComparisonNew(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');

         }
      }
   };


   const calculateYAxis = (data) => {
      if (!data || data.length === 0) {
         return { max: 20, ticks: [0, 5, 10, 15, 20] };
      }

      // Get all values from all categories
      const allValues = data.flatMap(item => [
         item.wedding || 0,
         item.single || 0,
         item.prom || 0
      ]);

      const maxValue = Math.max(...allValues);
      const roundedMax = Math.ceil(maxValue / 5) * 5;
      const finalMax = roundedMax === 0 ? 20 : roundedMax;

      const tickCount = 5;
      const tickStep = finalMax / (tickCount - 1);
      const ticks = Array.from({ length: tickCount }, (_, i) => Math.round(i * tickStep));

      return { max: finalMax, ticks };
   };

   // Prepare data for the new chart
   const transformChartData = (apiData) => {
      if (!apiData || apiData.length == 0) {
         return [];
      }

      const years = Object.keys(apiData[0]).filter(k => k != "category");

      return years.map(year => {
         let obj = { name: year };

         apiData.forEach(item => {
            const key = item.category.toLowerCase();
            obj[key] = item[year] || 0;
         });

         return obj;
      });
   };


   const newChartData = transformChartData(MonthlyComparisonNew); console.log(newChartData, "newChartData==============")

   const { max: newYAxisMax, ticks: newYAxisTicks } = calculateYAxis(newChartData);
   const currentYear = new Date().getFullYear();

   const [selectedYear, setSelectedYear] = useState(currentYear);

   const years = [currentYear, currentYear - 1, currentYear - 2];

   useEffect(() => {
      SalesPerformance(selectedYear);
   }, []);

   const SalesPerformance = async () => {
      try {
         const api = `sales-performance`;
         const response = await get(api);

         if (response?.status == true) {
            setSalesPerf(response?.data);
         }

      } catch (err) {
         console.error('Error:', err);

         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      }
   };

   const handleYearChange = (e) => {
      const year = e.target.value;
      setSelectedYear(year);
      fetchTopStores(year);
   };

   const OrderOverwiew = async () => {
      try {
         const api = `orders-overview`;
         const response = await get(api);
         setOrderview(response?.data)
         if (response?.status == true) {
            setOrderview(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const prepareOverviewChartData = () => {
      return Orderview.map(item => ({
         name: item.month,
         currentOverview: item.currentYearCount,
         previousOverview: item.previousYearCount
      }));
   };

   const calculateOverviewYAxisScale = (data) => {
      if (data.length === 0) return { overviewTicks: [0, 100, 200, 300, 400], overviewMax: 400 };

      const overviewMaxValue = Math.max(...data.flatMap(item => [item.currentOverview, item.previousOverview]));

      let increment = 50;
      if (overviewMaxValue > 500) increment = 100;
      if (overviewMaxValue > 1000) increment = 200;

      const overviewRoundedMax = Math.ceil(overviewMaxValue / increment) * increment + increment;

      const overviewTicks = [];
      for (let i = 0; i <= overviewRoundedMax; i += increment) {
         overviewTicks.push(i);
      }

      return { overviewTicks, overviewMax: overviewRoundedMax };
   };

   const overviewChartData = prepareOverviewChartData();
   const { overviewTicks, overviewMax } = calculateOverviewYAxisScale(overviewChartData);

   const MonthlyComparison = async () => {
      try {
         const api = `monthly-comparison`;
         const response = await get(api);
         if (response?.status == true) {
            setMonthlyComp(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const AccountOverview = async () => {
      try {
         const api = `account-overview`;
         const response = await get(api);
         if (response?.status == true) {
            setAccOverview(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   useEffect(() => {
      AccountOverview()
      MonthlyComparison()
      OrderOverwiew()
      SalesPerformance()
      MonthlyComparisonNewAPI()
   }, []);


   const profile = useSelector((state) => state.profile.profile);
   const isAdmin = profile?.name === "Admin";

   const getFirst = (arr) => Array.isArray(arr) && arr.length ? [arr[0]] : [];

   // ✅ ONLY Sales Performance should be compact
   const filteredSalesChartData = isAdmin ? salesChartData : getFirst(salesChartData);

   // ❌ DO NOT filter Orders Overview anymore
   const filteredOverviewChartData = overviewChartData;

   // compact mode only affects sales chart UI
   const isCompactChart = !isAdmin;
   const compactBarSize = 62;

   return (
      <>
         <Container>
            <div className="nk-content">
               <div className="container-fluid">
                  <div className="nk-content-inner">
                     {loading ?
                        <Loader />
                        :
                        <>
                           <div className="nk-content-body">
                              <div className="nk-block-head nk-block-head-sm pbZeroHeadin">
                                 <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                       <h3 className="nk-block-title page-title">Dashboard</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                       <div className="toggle-wrap nk-block-tools-toggle">
                                          <div className="toggle-expand-content" data-content="pageMenu">
                                             <ul className="nk-block-tools g-3">
                                                <li className="nk-block-tools-opt">
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="card card-preview">
                                 <div className="card-inner">
                                    <TopMetrics ActiveOrder={ActiveOrder} />
                                    {/* NEW CHART WITH THREE BARS */}
                                    <div className="row g-gs mt-2">
                                       <div className="col-lg-7 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title">
                                                   <h6 className="title">Current Month vs. Same Month Last Year</h6>
                                                </div>
                                             </div>
                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{ height: '300px', width: "100%" }}>
                                                      <ResponsiveContainer width="100%" height="100%">
                                                         <BarChart
                                                            data={newChartData}
                                                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                                            barGap={10}
                                                            barCategoryGap={20}
                                                         >
                                                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                            <XAxis
                                                               dataKey="name"
                                                               axisLine={false}
                                                               tickLine={false}
                                                            />
                                                            <YAxis
                                                               axisLine={false}
                                                               tickLine={false}
                                                               ticks={newYAxisTicks}
                                                               domain={[0, newYAxisMax]}
                                                            />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar
                                                               dataKey="wedding"
                                                               name="Wedding"
                                                               fill="#009299"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="single"
                                                               name="Single"
                                                               fill="#003f72"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="prom"
                                                               name="Prom"
                                                               fill="#7ed956"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                         </BarChart>
                                                      </ResponsiveContainer>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>

                                       <TopFiveRental />
                                    </div>

                                    {/* OTHER CHARTS */}
                                    <div className="row g-gs mt-2">
                                       <div className="col-md-7 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title">
                                                   <h6 className="title">Sales Performance</h6>
                                                </div>
                                                <div className="card-tools">
                                                   <div className="selectBoxMonth">
                                                      <select value={selectedYear} onChange={handleYearChange}>
                                                         {years.map((year) => (
                                                            <option key={year} value={year}>{year}</option>
                                                         ))}
                                                      </select>
                                                   </div>
                                                </div>
                                             </div>

                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{ height: "300px", width: "100%" }}>
                                                      <ResponsiveContainer width="100%" height="100%">
                                                         {filteredSalesChartData.length > 0 ? (
                                                            <BarChart
                                                               data={filteredSalesChartData}
                                                               margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                                               barGap={isCompactChart ? 16 : 10}
                                                               barCategoryGap={isCompactChart ? "45%" : "20%"}
                                                            >
                                                               <CartesianGrid strokeDasharray="3 3" vertical={false} />

                                                               <XAxis
                                                                  dataKey="name"
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  padding={isCompactChart ? { left: 60, right: 60 } : { left: 0, right: 0 }}
                                                               />

                                                               <YAxis
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  domain={[0, salesChartMax]}
                                                               />

                                                               <Tooltip />
                                                               <Legend verticalAlign={isCompactChart ? "top" : "bottom"} />

                                                               <Bar dataKey="current" name="Wedding" fill="#6ce5e8" radius={[4, 4, 0, 0]} barSize={isCompactChart ? compactBarSize : 22} />
                                                               <Bar dataKey="previous" name="Single" fill="#41b8d5" radius={[4, 4, 0, 0]} barSize={isCompactChart ? compactBarSize : 22} />
                                                               <Bar dataKey="prom" name="Prom" fill="#2d8bba" radius={[4, 4, 0, 0]} barSize={isCompactChart ? compactBarSize : 22} />
                                                            </BarChart>
                                                         ) : (
                                                            <div className="text-center mt-5">Loading Chart...</div>
                                                         )}
                                                      </ResponsiveContainer>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>



                                       {/* ORDERS OVERVIEW */}

                                       <div className="col-md-5 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title">
                                                   <h6 className="title">Orders Overview</h6>
                                                </div>
                                             </div>

                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{ height: "300px", width: "100%", overflowX: "auto", overflowY: "hidden" }}>
                                                      <div style={{ height: "300px", width: "100%" }}>
                                                         <ResponsiveContainer width="100%" height="100%">
                                                            <BarChart
                                                               data={filteredOverviewChartData}
                                                               margin={{ top: 0, right: 0, left: 0, bottom: 5 }}
                                                               barGap={10}
                                                               barCategoryGap={20}
                                                            >
                                                               <CartesianGrid strokeDasharray="3 3" vertical={false} />

                                                               <XAxis
                                                                  dataKey="name"
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  tick={{ angle: -45, textAnchor: "end", fontSize: 10 }}
                                                                  interval={0}
                                                               />

                                                               <YAxis
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  ticks={overviewTicks}
                                                                  domain={[0, overviewMax]}
                                                               />

                                                               <Tooltip />
                                                               <Legend />

                                                               <Bar dataKey="currentOverview" name="This year" fill="#F1CAC6" barSize={12} />
                                                               <Bar dataKey="previousOverview" name="Previous year" fill="#A4C3D2" barSize={12} />
                                                            </BarChart>
                                                         </ResponsiveContainer>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>


                                    <div className="row g-gs mt-2">
                                       <div className="col-md-12 priceList">
                                          <div className="mResponsive">
                                             <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                   <a className="nav-link active" data-bs-toggle="tab" href="#tabItem1">Recent Orders</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem2">Account Overview</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem3">Active Rentals</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem4">Most Rented Styles Report</a>
                                                </li>
                                             </ul>
                                          </div>
                                          <div className="tab-content">

                                             <div className="tab-pane active" id="tabItem1">
                                                <RecentOrdersTab />
                                             </div>

                                             <div className="tab-pane" id="tabItem2">
                                                <AccountOverviewTable />
                                             </div>

                                             <div className="tab-pane" id="tabItem3">
                                                <ActiveRentalTab />
                                             </div>

                                             <div className="tab-pane" id="tabItem4">
                                                <MostRental />
                                             </div>

                                          </div>

                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </>}
                  </div>
               </div>
            </div>
         </Container >
      </>
   )
}

export default Dashboard;